import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DrawerFacadeService } from '../../alio/services/drawer.facade.service';
import { MENU_CONFIG } from '../../core/config/menu.config';
import { MenuStructure } from '../../core/models/menu.models';
import { BreakpointFacadeService } from '../../shared/services/breakpoint.facade.service';
import { BreakpointService } from '../../shared/services/breakpoint.service';

@Component({
  selector: 'app-layout-shell',
  templateUrl: './layout-shell.component.html',
  styleUrls: ['./layout-shell.component.scss'],
  standalone: false,
})
export class LayoutShellComponent implements OnInit, OnDestroy {
  sidebarOpen = true;
  sidebarMode: 'side' | 'over' = 'side';
  menuConfig: MenuStructure = MENU_CONFIG;
  isResizingAlio = false;

  private destroy$ = new Subject<void>();
  private onPointerMove = (event: PointerEvent) => this.alioDrawer.setWidth(window.innerWidth - event.clientX);
  private onPointerUp = () => this.stopAlioResize();

  constructor(
    private breakpointService: BreakpointService,
    private breakpointFacade: BreakpointFacadeService,
    public alioDrawer: DrawerFacadeService,
  ) {}

  ngOnInit(): void {
    this.breakpointService.Size().pipe(takeUntil(this.destroy$)).subscribe();

    this.breakpointFacade.size$.pipe(takeUntil(this.destroy$)).subscribe((size) => {
      if (size === 'XSmall' || size === 'Small') {
        this.sidebarOpen = false;
        this.sidebarMode = 'over';
      } else {
        this.sidebarOpen = true;
        this.sidebarMode = 'side';
      }
    });
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  onAlioOpenedChange(opened: boolean): void {
    opened ? this.alioDrawer.open() : this.alioDrawer.close();
  }

  startAlioResize(event: PointerEvent): void {
    event.preventDefault();
    this.isResizingAlio = true;
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
  }

  private stopAlioResize(): void {
    this.isResizingAlio = false;
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  ngOnDestroy(): void {
    this.stopAlioResize();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
